<!-- src/components/CardStyleSettings.vue -->
<template>
    <div>
        <a-form class="style-settings card-style-form" :model="localCardStyles" layout="vertical" size="small">
            <!-- 透明度控制 -->
            <a-form-item label="透明度">
                <a-slider
                    v-model="localCardStyles.opacity"
                    :min="0.1"
                    :max="1"
                    :step="0.1"
                    show-input
                />
            </a-form-item>

            <!-- 背景颜色控制 -->
            <a-form-item label="背景颜色">
                <a-color-picker v-model="localCardStyles.backgroundColor" show-text />
            </a-form-item>

            <!-- 边框颜色控制 -->
            <a-form-item label="边框颜色">
                <a-color-picker v-model="localCardStyles.borderColor" show-text />
            </a-form-item>

            <!-- Box-Shadow 控制项 -->
            <a-form-item label="水平偏移">
                <a-input
                    v-model="localCardStyles.boxShadow.horizontal"
                    placeholder="例如：0px"
                >
                    <template #suffix>px</template>
                </a-input>
            </a-form-item>
            <a-form-item label="垂直偏移">
                <a-input
                    v-model="localCardStyles.boxShadow.vertical"
                    placeholder="例如：4px"
                >
                    <template #suffix>px</template>
                </a-input>
            </a-form-item>
            <a-form-item label="模糊半径">
                <a-input
                    v-model="localCardStyles.boxShadow.blur"
                    placeholder="例如：6px"
                >
                    <template #suffix>px</template>
                </a-input>
            </a-form-item>
            <a-form-item label="扩散半径">
                <a-input
                    v-model="localCardStyles.boxShadow.spread"
                    placeholder="例如：0px"
                >
                    <template #suffix>px</template>
                </a-input>
            </a-form-item>
            <a-form-item label="阴影颜色">
                <a-color-picker v-model="localCardStyles.boxShadow.color" show-text />
            </a-form-item>
            <a-form-item label="内阴影">
                <a-checkbox v-model="localCardStyles.boxShadow.inset">启用内阴影</a-checkbox>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="applyStyles">保存</a-button>
            </a-form-item>
        </a-form>
        <!-- 预览区域 -->
        <div class="preview-area">
            <div class="preview-card" :style="previewStyles">
                预览卡片
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { Message } from '@arco-design/web-vue';

export default defineComponent({
    name: 'CardStyleSettings',
    setup() {
        const store = useStore();

        const cardStyles = computed(() => store.state.sitesDiy.cardStyles);

        const localCardStyles = ref(JSON.parse(JSON.stringify(cardStyles.value)));

        watch(cardStyles, (newStyles) => {
            localCardStyles.value = JSON.parse(JSON.stringify(newStyles));
        }, { deep: true, immediate: true });

        const updateCardStyles = (styles) => store.dispatch('sitesDiy/updateCardStyles', styles);

        const applyStyles = async () => {
            try {
                await updateCardStyles(localCardStyles.value);
                Message.success('卡片样式已更新');
            } catch (error) {
                Message.error('更新样式失败');
                console.error('更新样式失败:', error);
            }
        };

        const previewStyles = computed(() => {
            const { opacity, backgroundColor, borderColor, boxShadow } = localCardStyles.value;
            let boxShadowValue = `${boxShadow.horizontal} ${boxShadow.vertical} ${boxShadow.blur} ${boxShadow.spread} ${boxShadow.color}${boxShadow.inset ? ' inset' : ''}`;
            return {
                opacity,
                backgroundColor,
                borderColor,
                boxShadow: boxShadowValue,
            };
        });

        return {
            localCardStyles,
            applyStyles,
            previewStyles,
        };
    }
});
</script>

<style scoped>
.style-settings {
    max-width: 400px;
    margin: 5px;
    border-radius: 12px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 20px;
    background: rgba(255, 255, 255, 0.1);
}

.preview-area {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.preview-card {
    width: 200px;
    height: 100px;
    border: 1px solid;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* font-family: 'Roboto', sans-serif; 使用全局字体 */
    font-weight: 500;
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}
</style>
